export default __webpack_public_path__ + "static/media/3.4ba1a228.jpg";